export default "__VITE_ASSET__BXrDem27__ 100w";